import { useState, FormEvent } from 'react';

export default function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    service: '',
    message: ''
  });

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    
    // Monta a mensagem para o WhatsApp
    let whatsappMessage = `*Nova Proposta Solicitada*\n\n`;
    whatsappMessage += `*Nome:* ${formData.name}\n`;
    whatsappMessage += `*E-mail:* ${formData.email}\n`;
    
    if (formData.phone) {
      whatsappMessage += `*Telefone:* ${formData.phone}\n`;
    }
    
    if (formData.company) {
      whatsappMessage += `*Empresa:* ${formData.company}\n`;
    }
    
    if (formData.service) {
      whatsappMessage += `*Serviço de Interesse:* ${formData.service}\n`;
    }
    
    whatsappMessage += `\n*Mensagem:*\n${formData.message}`;
    
    // Codifica a mensagem para URL
    const encodedMessage = encodeURIComponent(whatsappMessage);
    
    // Abre o WhatsApp com a mensagem
    window.open(`https://wa.me/5512981309575?text=${encodedMessage}`, '_blank');
    
    // Limpa o formulário
    setFormData({
      name: '',
      email: '',
      phone: '',
      company: '',
      service: '',
      message: ''
    });
  };

  const handleWhatsApp = () => {
    window.open('https://wa.me/5512981309575', '_blank');
  };

  return (
    <section id="contact" className="py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-red-900">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Vamos <span className="text-red-200">Conversar</span>
            <br />
            <span className="text-lg text-red-200 font-normal italic">"O caminho do guerreiro começa com uma conversa"</span>
          </h2>
          <p className="text-xl text-red-100 max-w-3xl mx-auto">
            Pronto para acelerar o crescimento do seu negócio? Entre em contato conosco e descubra como nossa expertise pode transformar seus resultados digitais.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
          <div className="bg-white/95 backdrop-blur-sm rounded-3xl p-8 shadow-xl">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Solicite uma Proposta Personalizada</h3>

            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Nome Completo *
                  </label>
                  <input
                    type="text"
                    name="name"
                    required
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-300"
                    placeholder="Seu nome completo"
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    E-mail *
                  </label>
                  <input
                    type="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-300"
                    placeholder="seu@email.com"
                  />
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Telefone/WhatsApp
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-300"
                    placeholder="(11) 99999-9999"
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Empresa
                  </label>
                  <input
                    type="text"
                    name="company"
                    value={formData.company}
                    onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-300"
                    placeholder="Nome da sua empresa"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Serviço de Interesse
                </label>
                <select
                  name="service"
                  value={formData.service}
                  onChange={(e) => setFormData({ ...formData, service: e.target.value })}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-300"
                >
                  <option value="">Selecione um serviço</option>
                  <option value="Growth Marketing">Growth Marketing</option>
                  <option value="Inteligência Artificial">Inteligência Artificial</option>
                  <option value="SEO & SEM">SEO & SEM</option>
                  <option value="Analytics & BI">Analytics & BI</option>
                  <option value="Marketing de Conteúdo">Marketing de Conteúdo</option>
                  <option value="Social Media">Social Media</option>
                  <option value="Consultoria Estratégica">Consultoria Estratégica</option>
                  <option value="Outro">Outro</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Mensagem *
                </label>
                <textarea
                  name="message"
                  required
                  rows={5}
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-300 resize-none"
                  placeholder="Conte-nos sobre seu projeto e objetivos..."
                  maxLength={500}
                ></textarea>
                <p className="text-xs text-gray-500 mt-1">Máximo de 500 caracteres</p>
              </div>

              <button
                type="submit"
                className="w-full bg-green-500 hover:bg-green-600 text-white py-4 rounded-lg font-semibold text-lg hover:shadow-lg transition-all duration-300 hover:scale-105 flex items-center justify-center space-x-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-2xl"></i>
                <span>Enviar via WhatsApp</span>
              </button>
            </form>
          </div>

          <div className="space-y-8">
            <div className="bg-white rounded-3xl p-8 shadow-xl">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Informações de Contato</h3>

              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="bg-red-100 p-3 rounded-full w-12 h-12 flex items-center justify-center">
                    <i className="ri-map-pin-line text-red-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Localização</h4>
                    <p className="text-gray-600">São José dos Campos, SP</p>
                    <p className="text-sm text-gray-500">Atendemos clientes em todo o Brasil</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="bg-red-100 p-3 rounded-full w-12 h-12 flex items-center justify-center">
                    <i className="ri-whatsapp-line text-red-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">WhatsApp</h4>
                    <p className="text-gray-600">(12) 98130-9575</p>
                    <button
                      onClick={handleWhatsApp}
                      className="text-sm text-red-600 hover:text-red-700 font-medium cursor-pointer"
                    >
                      Clique para conversar →
                    </button>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="bg-red-100 p-3 rounded-full w-12 h-12 flex items-center justify-center">
                    <i className="ri-mail-line text-red-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">E-mail</h4>
                    <p className="text-gray-600">atendimento@ichiban1.com.br</p>
                    <p className="text-sm text-gray-500">Resposta em até 24h</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="bg-red-100 p-3 rounded-full w-12 h-12 flex items-center justify-center">
                    <i className="ri-time-line text-red-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Horário de Atendimento</h4>
                    <p className="text-gray-600">Segunda a Sexta: 9h às 18h</p>
                    <p className="text-sm text-gray-500">Suporte 24/7 para clientes</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r from-red-600 to-red-500 rounded-3xl p-8 text-white">
              <h3 className="text-2xl font-bold mb-4">Consultoria Gratuita</h3>
              <p className="mb-6 text-red-100">
                Agende uma conversa de 30 minutos para discutir suas necessidades e descobrir como podemos ajudar seu negócio a crescer.
              </p>
              <button
                onClick={handleWhatsApp}
                className="bg-white text-red-600 px-6 py-3 rounded-full font-semibold hover:shadow-lg transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                Agendar Consultoria
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
